var map = {
	"./mood1.png": "7dlP",
	"./mood10.png": "yFHk",
	"./mood11.png": "5uow",
	"./mood12.png": "5j8A",
	"./mood13.png": "ouLl",
	"./mood14.png": "cwR5",
	"./mood15.png": "TqaM",
	"./mood2.png": "U0VO",
	"./mood3.png": "7oZu",
	"./mood4.png": "XUuf",
	"./mood5.png": "JwOA",
	"./mood6.png": "G33G",
	"./mood7.png": "niC7",
	"./mood8.png": "eSpz",
	"./mood9.png": "JTq7"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "tLMc";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moods ^\.\/.*$
// module id = tLMc
// module chunks = 1